import React from 'react';
import cx from 'classnames';
import { PropTypes } from 'prop-types';

const StepsBar = ({ className, currentStep, stepsLength, error }) => {
  return (
    <div className={className}>
      <ul className="steps-bar__list">
        {[...Array(stepsLength)].map((item, index) => {
          return (
            <li
              key={`steps-bar-${index}`}
              className={cx(
                { 'steps-bar__item--active': index + 1 <= currentStep },
                { 'steps-bar__item--red': error },
                'steps-bar__item'
              )}
            />
          );
        })}
      </ul>
    </div>
  );
};

StepsBar.defaultProps = {
  stepsLength: 4,
  error: false,
};

StepsBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  stepsLength: PropTypes.number,
  error: PropTypes.bool,
};

export default StepsBar;
